import React from 'react'

import Grid from '@material-ui/core/Grid'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import AppBar from '@material-ui/core/AppBar'
import Dedupe from '../../Component/Dedupe'

export default class extends React.Component {

  state = {
    UserTabSelected: 0
  }

  outils = [
    {
      nom: 'Dédoublonner',
      component: <Dedupe/>
    },
  ]

  handleChange = (_, value) => {
    this.setState({
      UserTabSelected: value
    })
  }

  render () {
    return <Grid container style={{ margin: 0, padding: 0, width: '100%', position: 'relative' }} spacing={0}>
      <Grid item xs={12}>
        <AppBar position="static" color="default">
          <Tabs
            value={this.state.UserTabSelected}
            onChange={this.handleChange}
            style={{ maxWidth: '100%', width: '100%' }}
            variant="scrollable"
            scrollButtons="on">
            {
              this.outils.map((configuration, i) =>
                <Tab key={i} value={i} label={configuration.nom}/>
              )
            }
          </Tabs>
        </AppBar>
        {
          this.outils[this.state.UserTabSelected].component
        }
      </Grid>
    </Grid>
  }
}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Page/Outils/index.js